import { generatePath, Navigate } from "react-router-dom";
import { POST_MODERATION_PATH } from "@/modules/feed";

/**
 * Уведомление о посте, ждущем проверки, ведёт сюда:
 * /gateway/OpenPostForModeration?id=<postId>.
 */
export function OpenPostForModeration() {
  const url = new URL(window.location.href);
  const postId = url.searchParams.get("id");

  if (!postId) {
    return <Navigate to="/" />;
  }

  return <Navigate to={generatePath(POST_MODERATION_PATH, { postId })} />;
}
